import { useState } from "react";
import { motion } from "motion/react";
import PawLogo from "../ui/PawLogo";

export default function ContactSection({
                                           kennelName,
                                           primaryColor,
                                           styles,
                                           contact = {
                                               address: "Lange Str. 35, 26434 Wangerland OT Hooksiel",
                                               phone: "+49 175 3203089",
                                               email: "Havaneser@vom-schnuesterhus.de",
                                           },

                                           socialLinks = {
                                               instagram:
                                                   "https://www.instagram.com/havaneser_vom_schnuesterhus/?utm_source=qr&igsh=OTUzcThtOXBqbDZl#",
                                               facebook:
                                                   "https://www.facebook.com/people/Havaneser-vom-Schn%C3%BCsterhus/61584841313529/?rdid=fHzDfYdmIBwFC55q&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14UnwnoskZo%2F",
                                           },

                                           formspreeEndpoint = "https://formspree.io/f/mjgggkqn", // <-- PLATZHALTER

                                           // ✅ NEU: öffnet Datenschutz-Modal
                                           onOpenPrivacy, // <-- (e) => void
                                       }) {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const resetSuccessLater = () => {
        setTimeout(() => setFormSubmitted(false), 5000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitError("");

        if (!formspreeEndpoint || formspreeEndpoint.includes("DEIN_FORM_ID_HIER")) {
            setSubmitError("Bitte zuerst den Formspree-Link (formspreeEndpoint) eintragen.");
            return;
        }

        try {
            setIsSubmitting(true);

            const res = await fetch(formspreeEndpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    message: formData.message,
                    _subject: `Neue Kontaktanfrage – ${kennelName || "Website"}`,
                }),
            });

            if (!res.ok) {
                let msg = "Senden fehlgeschlagen. Bitte später erneut versuchen.";
                try {
                    const data = await res.json();
                    if (data?.errors?.length) msg = data.errors.map((er) => er.message).join(" ");
                } catch (_) {}
                throw new Error(msg);
            }

            setFormSubmitted(true);
            setFormData({ name: "", email: "", phone: "", message: "" });
            resetSuccessLater();
        } catch (err) {
            setSubmitError(err?.message || "Senden fehlgeschlagen.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <section style={styles.section}>
            <motion.h2
                style={{ ...styles.sectionTitle, color: primaryColor }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
            >
                Kontaktieren Sie uns
            </motion.h2>

            <div style={styles.contactContainer}>
                {/* Left: Info */}
                <motion.div
                    style={styles.contactInfo}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h3 style={{ color: primaryColor, fontFamily: "'Playfair Display', serif" }}>
                        {kennelName}
                    </h3>

                    <div style={styles.contactDetail}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                                stroke={primaryColor}
                                strokeWidth="2"
                            />
                            <path
                                d="M12 21C16 17 20 13.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 13.4183 8 17 12 21Z"
                                stroke={primaryColor}
                                strokeWidth="2"
                            />
                        </svg>
                        <p>{contact.address}</p>
                    </div>

                    <div style={styles.contactDetail}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M22 12C22 10.6868 21.7413 9.38647 21.2388 8.1731C20.7362 6.95996 19.9997 5.85742 19.0711 4.92896C18.1425 4.00024 17.0401 3.26367 15.8268 2.76123C14.6136 2.25854 13.3132 2 12 2C10.6868 2 9.38647 2.25854 8.1731 2.76123C6.95996 3.26367 5.85742 4.00024 4.92896 4.92896C3.26267 6.59558 2 8.69378 2 12C2 14.0847 2.18 15.5301 2.67298 16.9014C3.15933 18.2608 3.93935 19.4171 5 20.4076V22L7 21C8.28104 21.5238 9.80576 22 12 22C14.3063 22 16.4042 20.7373 18.0711 19.0711C19.9997 17.1425 22 14.6563 22 12Z"
                                stroke={primaryColor}
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <p>{contact.phone}</p>
                    </div>

                    <div style={styles.contactDetail}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                                stroke={primaryColor}
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M22 6L12 13L2 6"
                                stroke={primaryColor}
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <p>{contact.email}</p>
                    </div>

                    <p style={styles.contactText}>
                        Wir freuen uns über Ihr Interesse an unseren Havaneser Welpen! Gerne beantworten wir Ihre Fragen
                        und vereinbaren einen persönlichen Besuchstermin, damit Sie unsere Hunde kennenlernen können.
                    </p>

                    <div style={styles.socialmediaContainer}>
                        <motion.a
                            href={socialLinks.facebook}
                            style={styles.socialIcon}
                            whileHover={{ scale: 1.2, color: primaryColor }}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </motion.a>

                        <motion.a
                            href={socialLinks.instagram}
                            style={styles.socialIcon}
                            whileHover={{ scale: 1.2, color: primaryColor }}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2" />
                                <path d="M16.5 7.5h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path
                                    d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                />
                            </svg>
                        </motion.a>
                    </div>
                </motion.div>

                {/* Right: Form */}
                <motion.div
                    style={styles.contactForm}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    viewport={{ once: true }}
                >
                    {formSubmitted ? (
                        <motion.div
                            style={styles.formSuccess}
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div style={styles.successIcon}>
                                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999"
                                        stroke={primaryColor}
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M22 4L12 14.01L9 11.01"
                                        stroke={primaryColor}
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>

                            <h3 style={{ color: primaryColor, fontFamily: "'Playfair Display', serif" }}>
                                Vielen Dank für Ihre Nachricht!
                            </h3>
                            <p>Wir werden uns so schnell wie möglich bei Ihnen melden.</p>
                            <PawLogo color={primaryColor} size={60} />
                        </motion.div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            {submitError ? (
                                <div
                                    style={{
                                        marginBottom: 14,
                                        padding: "12px 12px",
                                        borderRadius: 12,
                                        background: "rgba(220, 38, 38, 0.08)",
                                        border: "1px solid rgba(220, 38, 38, 0.18)",
                                        color: "#b91c1c",
                                        fontSize: 13.5,
                                        lineHeight: 1.4,
                                    }}
                                >
                                    {submitError}
                                </div>
                            ) : null}

                            <div style={styles.formGroup}>
                                <label htmlFor="name" style={styles.label}>Name *</label>
                                <motion.input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                    style={styles.input}
                                    whileFocus={{ boxShadow: `0 0 0 2px ${primaryColor}` }}
                                />
                            </div>

                            <div style={styles.formGroup}>
                                <label htmlFor="email" style={styles.label}>Email *</label>
                                <motion.input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                    style={styles.input}
                                    whileFocus={{ boxShadow: `0 0 0 2px ${primaryColor}` }}
                                />
                            </div>

                            <div style={styles.formGroup}>
                                <label htmlFor="phone" style={styles.label}>Telefon</label>
                                <motion.input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    whileFocus={{ boxShadow: `0 0 0 2px ${primaryColor}` }}
                                />
                            </div>

                            <div style={styles.formGroup}>
                                <label htmlFor="message" style={styles.label}>Nachricht *</label>
                                <motion.textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                    style={styles.textarea}
                                    whileFocus={{ boxShadow: `0 0 0 2px ${primaryColor}` }}
                                />
                            </div>

                            {/* ✅ DSGVO/Datenschutz Hinweis – öffnet Modal */}
                            <p style={{ margin: "10px 0 14px", fontSize: 12.5, lineHeight: 1.45, opacity: 0.85 }}>
                                Mit dem Absenden des Formulars bestätigen Sie, die{" "}
                                <button
                                    type="button"
                                    onClick={(e) => onOpenPrivacy?.(e)}
                                    style={{
                                        appearance: "none",
                                        border: "none",
                                        background: "transparent",
                                        padding: 0,
                                        margin: 0,
                                        cursor: "pointer",
                                        color: primaryColor,
                                        font: "inherit",
                                        borderBottom: `1px solid ${primaryColor}55`,
                                    }}
                                >
                                    Datenschutzerklärung
                                </button>{" "}
                                zur Kenntnis genommen zu haben.
                            </p>

                            <motion.button
                                type="submit"
                                disabled={isSubmitting}
                                style={{
                                    ...styles.button,
                                    backgroundColor: primaryColor,
                                    width: "100%",
                                    opacity: isSubmitting ? 0.75 : 1,
                                    cursor: isSubmitting ? "not-allowed" : "pointer",
                                }}
                                whileHover={{ backgroundColor: primaryColor }}
                                whileTap={{ scale: 0.95 }}
                            >
                                {isSubmitting ? "Sende..." : "Nachricht senden"}
                            </motion.button>
                        </form>
                    )}
                </motion.div>
            </div>
        </section>
    );
}
